export enum RoutingEnum {
  INITIAL_AUTH,
  HOME,
  TERMS_AND_CONDITIONS,
  LOGIN,
  UPDATE,
  LOADING,
  NO_CONNECTION,
  PERMISSION_REVOKED,
  /** The registration screens own the screen; the pipeline must not navigate. */
  REGISTRATION
}